import React, {useEffect} from 'react';
import styled from 'styled-components';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import {minmax} from 'utils/minmax';
import {colors} from 'styles/colors';
import RadioButton from 'components/common/RadioButton';
import DefaultButton from 'components/common/DefaultButton';
import DefaultFormattedMessage from 'components/common/DefaultFormattedMessage';
import {ISubscriptionProduct} from 'interfaces/interface';

/**
 * 플랜 선택 컴포넌트의 Props 인터페이스
 * @property {React.Dispatch<React.SetStateAction<number>>} setStep - 단계 설정 함수
 * @property {() => void} [closeModal] - 모달 닫기 함수
 * @property {any[] | null} plansData - 플랜 데이터 목록
 * @property {React.Dispatch<React.SetStateAction<number>>} setTotalAmount - 총 금액 설정 함수
 * @property {number} totalAmount - 총 금액
 * @property {ISubscriptionProduct | undefined} basicPlan - 기본 플랜
 * @property {React.Dispatch<React.SetStateAction<ISubscriptionProduct | undefined>>} setBasicPlan - 기본 플랜 설정 함수
 */
interface IProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  closeModal?: () => void;
  plansData: any[] | null;
  setTotalAmount: React.Dispatch<React.SetStateAction<number>>;
  totalAmount: number;
  basicPlan: ISubscriptionProduct | undefined;
  setBasicPlan: React.Dispatch<
    React.SetStateAction<ISubscriptionProduct | undefined>
  >;
}

/**
 * 플랜 선택 컴포넌트
 * 구독할 플랜을 선택하는 컴포넌트입니다.
 * @param {IProps} props - 플랜 선택 컴포넌트의 props
 * @returns {JSX.Element} 플랜 선택 컴포넌트
 */
export default function SelectPlan({
  closeModal,
  setStep,
  plansData,
  setTotalAmount,
  totalAmount,
  basicPlan,
  setBasicPlan,
}: IProps) {
  useEffect(() => {
    if (plansData) {
      setTotalAmount(plansData[0].price);
      setBasicPlan(plansData[0]);
    }
  }, [plansData]);

  return (
    <>
      <Header>
        <DefaultText
          text="subscribePlan"
          textStyle={{
            fontSize: minmax(36),
            fontWeight: 'bold',
          }}
        />
        <DefaultImageView
          source="images/common/close.png"
          style={{
            width: minmax(26),
            cursor: 'pointer',
          }}
          onClick={closeModal}
        />
      </Header>
      <Inner>
        <PlanContainer>
          <Plan>
            <DefaultText
              text="basicPlan"
              textStyle={{fontSize: minmax(24), fontWeight: 'bold'}}
            />
            {basicPlan &&
              plansData?.map((plan, index) => {
                return (
                  <RadioTextWrap
                    key={index}
                    onClick={() => {
                      setBasicPlan(plan);
                      setTotalAmount(plan.price);
                    }}>
                    <RadioButton
                      checked={basicPlan.id === plan.id}
                      onChange={() => {
                        //
                      }}
                    />
                    <DefaultFormattedMessage
                      id="priceFormat"
                      values={{
                        price: `${plan.name} / ${plan.price.toLocaleString(
                          'ko-KR',
                        )}`,
                      }}
                      style={{
                        cursor: 'pointer',
                      }}
                    />
                  </RadioTextWrap>
                );
              })}
            {/* <RadioTextWrap>
              <RadioButton
                checked={basicPlan === 1}
                onChange={() => {
                  setBasicPlan(1);
                  setTotalAmount(priceList.basicPlan[0]);
                }}
              />
              <DefaultText text="스탠다드 플랜 / 77,000원" />
            </RadioTextWrap>
            <RadioTextWrap>
              <RadioButton
                checked={basicPlan === 2}
                onChange={() => {
                  setBasicPlan(2);
                  setTotalAmount(priceList.basicPlan[1]);
                }}
              />
              <DefaultText text="프리미엄 플랜 / 140,000원" />
            </RadioTextWrap> */}
          </Plan>
        </PlanContainer>
        <DefaultFormattedMessage
          id="planTotalAmount"
          values={{
            amount: totalAmount ? totalAmount.toLocaleString('ko-KR') : 0,
          }}
        />
      </Inner>
      <DefaultButton
        text={'next'}
        buttonStyle={{
          width: '100%',
          backgroundColor: colors.primary2,
        }}
        textStyle={{
          color: colors.white,
        }}
        onClick={() => setStep(1)}
      />
    </>
  );
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${minmax(34)};
`;

const Inner = styled.div`
  margin-bottom: ${minmax(28)};
`;

const PlanContainer = styled.div`
  border-bottom: 1px solid ${colors.darkGray};
  margin-bottom: ${minmax(20)};
`;

const Plan = styled.div`
  border-radius: ${minmax(10)};
  border: 1px solid ${colors.borderGray};
  background-color: ${colors.whiteSmoke};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${minmax(16)};
  row-gap: ${minmax(16)};
  margin-bottom: ${minmax(20)};
`;

const RadioTextWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: ${minmax(16)};
`;
